// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var universal = BsCssJs$PrezzeeRibbon.style([
      Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(0.875)),
      BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.rem(1.25)),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(6))
    ]);

var lightStyle = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.darkGrey)]);

var darkStyle = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white)]);

var error = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.important(BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.primaryRed))]);

var Styles = {
  universal: universal,
  lightStyle: lightStyle,
  darkStyle: darkStyle,
  error: error
};

function TextField__HelperText(props) {
  var className = props.className;
  var error$1 = props.error;
  var theme = props.theme;
  var theme$1 = theme !== undefined ? theme : /* Light */0;
  var error$2 = error$1 !== undefined ? error$1 : false;
  var className$1 = className !== undefined ? className : "";
  var errorStyle = error$2 ? error : "";
  var themeStyle = theme$1 ? darkStyle : lightStyle;
  var className$2 = Classnames([
        universal,
        themeStyle,
        errorStyle,
        className$1
      ]);
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: className$2
            });
}

var make = TextField__HelperText;

export {
  Styles ,
  make ,
}
/* universal Not a pure module */
